import DateColumn from '../column-helpers/date/date-component';
import PlanStatusComponent from '../column-helpers/plan_status/plan-status-component';
// import _ from 'lodash';

const PlatformSdk = require('@gluenetworks/platform-sdk-remote');

// const getMappedDeviceConstant = (deviceConstant) => {
//     const mappedObject = {};
//     Object.values(deviceConstant).forEach(el => {
//         mappedObject[el.name] = el.title;
//     });
//
//     return mappedObject;
// };

const OsUpgradePlan = PlatformSdk.entities.ws.OsUpgradePlan;

export const osPlansColumnConfig = {
  action: {
    label: 'Action',
    type: 'select',
    options: OsUpgradePlan.OS_UPGRADE_ACTION,
    width: 220,
    shown: false,
    priority: 1,
  },
  name: {
    label: 'Name',
    type: 'text',
    width: 220,
    shown: true,
    priority: 2,
  },
  description: {
    label: 'Description',
    type: 'text',
    width: 300,
    shown: false,
    priority: 3,
  },
  deviceCount: {
    label: 'Total Devices',
    dataType: 'integer',
    width: 140,
    shown: false,
    priority: 4,
    validation: {
      min: 0,
    },
  },
  deviceSuccessCount: {
    label: 'Successful Devices',
    dataType: 'integer',
    width: 160,
    shown: true,
    priority: 5,
    validation: {
      min: 0,
    },
  },
  deviceFailureCount: {
    label: 'Failed Devices',
    dataType: 'integer',
    width: 140,
    shown: true,
    priority: 6,
    validation: {
      min: 0,
    },
  },
  status: {
    label: 'Plan Status',
    type: 'select',
    columnRendererComponent: PlanStatusComponent,
    options: OsUpgradePlan.OS_UPGRADE_STATUS,
    context: {
      _planStatusList: OsUpgradePlan.OS_UPGRADE_STATUS,
    },
    width: 140,
    shown: true,
    priority: 7,
  },
  createdBy: {
    label: 'Created By',
    type: 'text',
    updateFromEntity: true,
    width: 110,
    shown: false,
    priority: 8,
  },
  createdOn: {
    label: 'Created On',
    type: 'datetime',
    columnRendererComponent: DateColumn,
    updateFromEntity: true,
    width: 110,
    shown: false,
    priority: 9,
  },
  updatedBy: {
    label: 'Updated By',
    type: 'text',
    width: 120,
    shown: false,
    priority: 10,
  },
  updatedOn: {
    label: 'Updated On',
    type: 'datetime',
    columnRendererComponent: DateColumn,
    width: 160,
    shown: false,
    priority: 11,
  },
};
